import request from '@/utils/request';

export function getVapidKey() {
  return request({
    url: '/push-subscriptions/vapid-key',
    method: 'get',
  });
}

export function subscribeToPushNotifications(subscription) {
  return request({
    url: '/push-subscriptions/subscribe',
    method: 'post',
    data: {
      endpoint: subscription.endpoint,
      keys: {
        p256dh: subscription.keys.p256dh,
        auth: subscription.keys.auth,
      },
    },
  });
}

export function unsubscribeFromPushNotifications(subscription) {
  return request({
    url: '/push-subscriptions/unsubscribe',
    method: 'post',
    data: {
      endpoint: subscription.endpoint,
    },
  });
}

export function toggleEmailSubscription(status) {
  return request({
    url: '/email-subscriptions/toggle',
    method: 'post',
    data: {
      status: status,
    },
  });
}
